/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOnboardingConfigRequest} from '@cash-web/protos/squareup/cash/semaphore/api/GetOnboardingConfig.pb'
import {GetOnboardingConfigResponse} from '@cash-web/protos/squareup/cash/semaphore/api/GetOnboardingConfig.pb'


export const getOnboardingConfig = (request: GetOnboardingConfigRequest, options?: CashRequestOptions) => post<GetOnboardingConfigRequest, GetOnboardingConfigResponse>("/2.0/cash/get-onboarding-config", request, {...options, rejectOnError: true })